import { requiredWithSpecificMessage } from "@js/forms/validators";

export const paymentMethodsValidator = requiredWithSpecificMessage(
  "Please add a payment method",
);
